/**
 * Created by supunm on 2/15/19.
 */

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name crewViolations.service:crewViolationsService
   *
   * @description
   *
   */
  angular
    .module('consecutiveDayFlightAndEarlyMorningDeparture')
    .service('dayAndEarlyMorningFlightService', dayAndEarlyMorningFlightService);

  function dayAndEarlyMorningFlightService(CommonMasterData,RemoteService) {
    var vm = this;

    vm.searchDayAndEarlyMorningFlight = function (param ,successFn,errorFn) {
      var searchParam = adaptSearchRequset(param);
      RemoteService.searchDayAndEarlyMorningFlight(searchParam).then(
        function (response) {
          successFn(response);
        },
        function (error) {
          errorFn(error.msg);
        }
      );
    };

    function adaptSearchRequset(param) {
      var actualSearchParam = {
        fromDate : param.fromDate,
        toDate: param.toDate,
        acType: (param.aircraftType != null) ? param.aircraftType.airCraftType : null,
        crewType:(param.crewType !=null ) ? param.crewType.crewTypeCode:null,
        blankDaysOnly: param.blankDaysOnly,
        autoOrManual: (param.autoOrManual != null) ? param.autoOrManual.autoOrManualCode:null
      };

      return actualSearchParam;
    }

  }
}());
